//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: 'SurveySectionPage',

  layout: 'page',

  data() {
    const { sectionId, floorId } = this.$route.query

    return {
      pageLoading: false,
      sectionId,
      floorId,
      steps: [],
      activeStep: 0,
      questions: {},
      answeredQuestions: [],
      stepAnswers: [],
    }
  },

  computed: {
    floor() {
      return this.$store.state.surveyFloors.find(
        (floor) => floor.id === this.floorId
      )
    },
    curSection() {
      return this.$store.state.surveySections?.find(
        (section) => section.id === this.sectionId
      )
    },
    sectionTitle() {
      return this.curSection?.title
    },
    contractId() {
      return this.curSection?.contractId
    },
    pageTitle() {
      if (this.activeStepName === 'completed') {
        return '設定内容のご確認'
      }

      return this.sectionTitle
    },
    nextStepDisabled() {
      if (this.sectionId === 'ConfirmationOfContractAgreement') {
        const filtered = this.answeredQuestions.filter(Boolean)

        return (
          filtered.length < 2 || !filtered.every((item) => item.options?.length)
        )
      }

      return (
        !this.answeredQuestions.length ||
        this.answeredQuestions.some((item) => !item.options?.length)
      )
    },
    activeStepName() {
      return this.steps[this.activeStep]
    },
    answeredQuestionsLog() {
      return this.stepAnswers.flat()
    },
  },

  async mounted() {
    await this.getQuestion()
  },

  methods: {
    async getQuestion() {
      this.pageLoading = true

      const res = await this.$axios.$post(
        `/onboarding-survey/sections/${this.sectionId}/questions`,
        {
          contractId: this.contractId,
          answeredQuestions: this.answeredQuestions,
          answeredQuestionsLog: this.answeredQuestionsLog,
        }
      )

      this.pageLoading = false

      const questions = res.data?.questions || []

      if (questions.length) {
        const stepName = questions[0].id

        if (!this.steps.includes(stepName)) {
          this.steps.push(stepName)
        }

        this.questions[stepName] = questions.map((item) => ({
          ...item,
          type:
            this.sectionId === 'ConfirmationOfContractAgreement'
              ? 'agree-checkbox'
              : 'radio',
          title:
            item.id === 'ConfirmationOfContinuedUseAfterTrial'
              ? 'お申し込み情報をご確認ください'
              : item.title,
          options:
            this.sectionId === 'EmployeePaymentSetting' &&
            this.curSection?.is2026Plan
              ? item.options.filter((opt) => opt.title !== '一部補助')
              : item.options,
          footImgId:
            this.sectionId === 'EmployeePaymentSetting' &&
            this.curSection?.is2026Plan
              ? 'ob-question-price-2026.png'
              : item.footImgId,
        }))
      } else {
        this.steps.push('completed')
      }
    },
    doStep(step) {
      if (step < this.steps.length) {
        this.steps = this.steps.slice(0, step + 1)
        this.stepAnswers = this.stepAnswers.slice(0, step + 1)
      }

      this.activeStep = step

      const curAnsweredQuestions = this.stepAnswers[this.activeStep]

      this.answeredQuestions = curAnsweredQuestions || []
    },
    async doNextStep() {
      // save answered questions before next step
      this.$set(this.stepAnswers, this.activeStep, this.answeredQuestions)

      await this.getQuestion()

      this.doStep(this.activeStep + 1)
    },
    doSelect(answers) {
      this.answeredQuestions = answers
    },
    async doConfirmStep() {
      this.pageLoading = true

      const res = await this.$axios.$post('/onboarding-survey/answer', {
        floorId: this.floorId,
        contractId: this.contractId,
        sectionId: this.sectionId,
        answeredQuestions: this.answeredQuestionsLog,
      })

      this.pageLoading = false

      const { result } = res.data || {}

      if (!result) {
        this.$message({
          type: 'error',
          message: '送信に失敗しました。',
        })

        return
      }

      this.$store.commit('updateSurveyCompletedSection', this.sectionId)

      this.$router.replace({
        path: '/onboarding-survey',
        query: {
          floorId: this.floorId,
          step: 'sections',
        },
      })
    },
  },
}
